import { color, font, spaces } from "emoreg/const";
import { rem } from "polished";
import styled, { css } from "styled-components";
import { ifProp } from "styled-tools";
import { gutter } from "styles/const";
import { responsiveHelpers as rh } from "styles/utils";

const TabbarHeader = styled.div`
  margin-bottom: ${spaces[48]};
  margin-right: -${rem(gutter.base / 2)};
  border-bottom: 0.5px solid ${color.grey.base};
  display: flex;
  ${props =>
    props.withNegativeMargins &&
    css`
      padding-left: ${rem(props.withNegativeMargins)};
      padding-right: ${rem(props.withNegativeMargins)};
      margin-left: -${rem(props.withNegativeMargins)};
      margin-right: -${rem(props.withNegativeMargins)};
    `}
  ${rh.belowPortraitTablet`
    overflow-y: auto;
  `};
  ${rh.forPortraitTabletUp`
    margin-bottom: ${spaces[32]};
  `};
`;

const Tab = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: ${spaces[32]};
  padding-bottom: ${spaces[16]};
  cursor: pointer;
  position: relative;
  ${rh.belowPortraitTablet`
    flex-shrink: 0;
  `};
  ${ifProp(
    "selected",
    css`
      color: ${color.blue.base};
      font-weight: ${font.weight.semiBold};
      border-bottom: 2px solid ${color.blue.base};
    `
  )}
`;

const TabSurtitle = styled.span`
  display: block;
  margin-bottom: ${spaces[4]};
  font-size: ${rem(12)};
`;

const TabContent = styled.div``;

type TabbarProps = {
  children: React.ReactElement<{
    onSelect: () => void;
    surtitle: string;
    title: string;
  }>[];
  currentIndex: number;
  withNegativeMargins?: number;
};

export type TabProps = {
  surtitle: string;
  title: any;
  onSelect?: () => void;
  onContactCreated?: any;
};

const Tabbar = ({ children, currentIndex, withNegativeMargins }: TabbarProps) => {
  return (
    <>
      <TabbarHeader withNegativeMargins={withNegativeMargins}>
        {children.map((t, index) => {
          return (
            <Tab key={index} onClick={t.props.onSelect} selected={index === currentIndex}>
              <TabSurtitle>{t.props.surtitle}</TabSurtitle>
              <span>{t.props.title}</span>
            </Tab>
          );
        })}
      </TabbarHeader>
      <TabContent>
        <span>{children[currentIndex]}</span>
      </TabContent>
    </>
  );
};

export default Tabbar;
